<template>
  <div class="home">
    <navbar title="coupon" />
    <banner />
    <couponHome />
    <!-- <footerCarousel /> -->
    <footerBox />
  </div>
</template>

<script>
// @ is an alias to /src
import { banner, couponHome } from './component'
import navbar from '@/components/navbar.vue'
// import footerCarousel from '@/components/footerCarousel'
import footerBox from '@/components/footer.vue'

export default {
  name: 'Home',
  methods: {
    setHeight () {
      console.log(document.body.clientHeight)
      this.loginHeight = document.body.clientHeight
      console.log(this.loginHeight)
    }
  },
  components: {
    navbar,
    banner,
    couponHome,
    // footerCarousel,
    footerBox
  }
}
</script>
<style scoped>
.home {
  background: #fafafa;
  width: 100%;
  overflow: hidden;
}
</style>
